export default () => ({
    root: {
        "& .MuiPagination-ul": {
            justifyContent: "center",
        },
    },
});